export default __webpack_public_path__ + "static/char-34-anr-c5db4d056af4c7f0aef477868c8dc3b7.webp";